import React from 'react'
import styles from './styles/btn-with-check.module.scss'

interface BtnWithCheckProps {
  onClick?: () => any,
  isActive?: boolean
}

const BtnWithCheck: React.FC<BtnWithCheckProps> = ({ onClick, isActive, children }) => {

  return (
    <button type='button' className={styles.btnWithCheck} onClick={onClick}>
      {children}
      {isActive &&
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26">
          <path stroke="#737680" strokeLinecap="round" strokeWidth="1.7" d="M7.8 13.54l3.16 3.283c.04.041.106.04.145-.002L18.2 9.1" />
        </svg>

      }
    </button>
  )
}

export default BtnWithCheck